<!-- 
Contents of the NOTES tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="notes"
      module="providers"
      nav-url="/providers/:id/notes"
    />
    <tabs :provider-id="providerId" :incomplete-contacts="incompleteContacts">
      <notes-listing ref="notes" :provider-id="providerId" @click="showEditor" />
      <note-edit-dialog v-model="showEditDialog" :note-id="noteId" :provider-id="providerId" :levy-collection-id="null" />
    </tabs>
  </div>
</template>

<script>
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";
import NotesListing from "@/components/notes/NotesListing.vue";
import NoteEditDialog from "@/components/notes/NoteEditDialog.vue";

export default {
  name: "ProviderNotes",
  components: { Tabs, NotesListing, NoteEditDialog },
  mixins: [providerMixins],
  data() {
    return {
      showEditDialog: false,
      noteId: null
    };
  },
  methods: {
    showEditor(noteId) {
      this.noteId = noteId;
      this.showEditDialog = true;
    }
  }
};
</script>
